/* js/proBox.js */

jQuery( document ).ready(function( $ ) {


    $(".proBoxRow").slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: true,
        centerMode: true,
        centerPadding: '40',
        responsive: [
            {
                breakpoint: 1150,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 822,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });


});


